/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description:
 * @Date: 2020-07-28 19:51:43
 */
function init(isSpver) {
  hideFooter(isSpver);
  dealHomeBaipai(isSpver);
  dealListBaipai(isSpver);
  removeBack(isSpver);
  dealSearchHead(isSpver);
  dealFormBaipai(isSpver);
}

function getTarget(tag) {
  return document.querySelector(tag);
}

function createInput({ type, name, value }) {
  const input = document.createElement('input');
  input.setAttribute('type', type);
  input.setAttribute('name', name);
  input.setAttribute('value', value);
  return input;
}

function hideFooter(baipai) {
  if (baipai) {
    getTarget('div.footer') && (getTarget.style.display = 'none');
    getTarget('ul.recommend') && (getTarget.style.display = 'none');
  }
}

function dealHomeBaipai(baipai) {
  if (baipai) {
    getTarget('a.sapp-logo-replace') && (getTarget('a.sapp-logo-replace').style.display = 'block');
    getTarget('a.sapp-search-btn') && (getTarget('a.sapp-search-btn').style.display = 'block');
  } else {
    getTarget('img.sapp-logo') && (getTarget('img.sapp-logo').style.display = 'block');
  }
}

function dealListBaipai(baipai) {
  if (window.location.href.indexOf('/list/') > -1) {
    if (baipai) {
      getTarget('a.sapp-search-home') && (getTarget('a.sapp-search-home').style.display = 'none');
    }
  }
}

function removeBack() {
  const uigsUa = navigator.userAgent.toLowerCase();
  const len = uigsUa.indexOf('sogousearch') >= 0 ? 1 : 0;
  if (history.length > len && document.referrer) {
    getTarget('#goback') && (getTarget('#goback').style.display = 'block');
  } else {
    getTarget('.sapp-logo-replace') && (getTarget('.sapp-logo-replace').className = 'haveBack');
  }
}

function dealSearchHead() {
  const searchbox = getTarget('form.hhy-searchbox');
  if (searchbox) {
    searchbox.setAttribute('name', 'searchForm');
    searchbox.setAttribute('action', '/v');
    searchbox.setAttribute('method', 'get');
    searchbox.setAttribute('accept-charset', 'utf-8');
    searchbox.appendChild(createInput({ type: 'hidden', name: 'w', value: '06009900' }));
    searchbox.appendChild(createInput({ type: 'hidden', name: 'ie', value: 'utf8' }));
  }
  const hhyInput = getTarget('input.hhy-input');
  if (hhyInput) {
    hhyInput.setAttribute('name', 'query');
    hhyInput.setAttribute('id', 'keyword');
  }
  const hhySugg = getTarget('div.hhy-suggestion');
  if (hhySugg) {
    hhySugg.setAttribute('id', 'sug_wraper');
  }
  const formSapp = getTarget('form.sapp-search-query');
  if (formSapp) {
    formSapp.setAttribute('accept-charset', 'utf-8');
    formSapp.appendChild(createInput({ type: 'hidden', name: 'ie', value: 'utf8' }));
  }
}

function dealFormBaipai(baipai) {
  if (baipai) {
    if (document.querySelectorAll('input[name=spver]').length === 0) {
      const searchForm = document.querySelector('form[name=searchForm]');
      searchForm && searchForm.appendChild(createInput({ type: 'hidden', name: 'spver', value: '1' }));
    }
  }
}

module.exports = {
  init,
};
